<div class="approval-status-row">
    <div appLocalizationPopupDirective localizationCode="ApprovalStatus" class="label">
        {{ 'ApprovalStatus' | translate: {Default: "Approval Status"} }}
    </div>
    <div class="value">
        <mat-chip-list *ngIf="buySellPlanEmployee">
            <mat-chip [ngClass]="getStatusChipClass()">
            {{ buySellPlanEmployee.status?.name }}
            </mat-chip>
        </mat-chip-list>
    </div>
</div>